/*!
 * Alpha Posts - Version: 2.3.8
 * Indeed - Copyright (c) 2025
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

const listOptions = {
  valueNames: ['name'],
  pagination: [{
    innerWindow: 1,
    outerWindow: 1,
    item: '<li><button class="page"></button></li>',
  }],
};

let userList, paginationWrapper, nextButton, prevButton, alphaPostsSearch;
function nextPreviousInit() {
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.items.length / listOptions.page).toString();
  userList.on('filterComplete', () => updatePagination());
  userList.on('searchComplete', () => updatePagination());
  updatePageOnNumberClick();
  showNextPage();
  showPreviousPage();
}
function updatePagination() {
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.matchingItems.length / listOptions.page).toString();
  if (paginationWrapper.dataset.pages === '1') {
    const singlePaginationButton = document.querySelector('.alphaposts-pagination-wrapper li');
    singlePaginationButton.classList.add('single-page');
    nextButton.disabled = true;
  } else {
    nextButton.disabled = false;
  }
}
function updatePageOnNumberClick() {
    document.addEventListener('click', function(e) {
      if (e.target.closest('a.page')) {
        const pageNumber = e.target.innerText;
        if (pageNumber !== '...') {
          prevButton.disabled = false;
          nextButton.disabled = false;
          paginationWrapper.dataset.page = pageNumber;
        }
        if (pageNumber === '1') {
          prevButton.disabled = true;
        }
        if (paginationWrapper.dataset.pages === pageNumber) {
          nextButton.disabled = true;
        }
      }
    });
}
function showNextPage() {
    nextButton.addEventListener('click', function() {
      if (parseInt(paginationWrapper.dataset.page) < parseInt(paginationWrapper.dataset.pages)) {
        prevButton.disabled = false;
        if (parseInt(paginationWrapper.dataset.pages) - parseInt(paginationWrapper.dataset.page) === 1) {
          nextButton.disabled = true;
        }
        const start = parseInt(paginationWrapper.dataset.page) * listOptions.page + 1;
        userList.show(start, listOptions.page);
        paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page) + 1).toString();
      }
    });
}
function showPreviousPage() {
  prevButton.addEventListener('click', function() {
    if (parseInt(paginationWrapper.dataset.page) > 1) {
      nextButton.disabled = false;
      if (parseInt(paginationWrapper.dataset.page) === 2) {
        prevButton.disabled = true;
      }
      const start = ((parseInt(paginationWrapper.dataset.page) - 1) * listOptions.page + 1) - listOptions.page;
      userList.show(start, listOptions.page);
      paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page) - 1).toString();
    }
  });
}

function alphapostsReady() {
    initializeAlphapostsPageSize();
    userList = new List('alphaposts-list-wrapper', listOptions);
    alphaPostsSearch = document.querySelector('.alphaposts-search');

    const alphaPostsNoResults = document.querySelector('.alphaposts-no-results');
    const alphaPostsListWrapper = document.querySelector('.alphaposts-list');

    function doSearch(e) {
        if (userList.filtered) {
            userList.filter();
        }

        userList.fuzzySearch(e.target.value.trim(), ['name']);
    }

    if (alphaPostsSearch) {
        alphaPostsSearch.addEventListener('input', doSearch);
    }

    function showHideNoResults(e) {
        alphaPostsNoResults.style.display = (e.visibleItems.length === 0) ? 'block' : 'none';
        alphaPostsListWrapper.style.display = (e.visibleItems.length === 0) ? 'none' : 'block';
    }

    if (alphaPostsNoResults) {
        userList.on('searchComplete', showHideNoResults);
        userList.on('filterComplete', showHideNoResults);
    }
    setTimeout(()=>{
        paginationWrapper = document.querySelector('.alphaposts-pagination-wrapper');
        nextButton = document.querySelector('.alphaposts-pagination-arrow.next');
        prevButton = document.querySelector('.alphaposts-pagination-arrow.previous');
        nextPreviousInit();
    }, 0);
}

function initializeAlphapostsPageSize() {
    if (window.innerWidth < 579) {
        listOptions.page = 12;
    } else if (window.innerWidth < 768) {
        listOptions.page = 20;
    } else if (window.innerWidth < 992) {
        listOptions.page = 18;
    } else {
        listOptions.page = 40;
    }
}

function updateAlphapostsPageSize() {
    if (!userList) {
        return;
    }
    if (window.innerWidth < 579) {
        if (userList.page !== 12) {
            userList.page = 12;
            userList.update();
        }
    } else if (window.innerWidth < 768) {
        if (userList.page !== 20) {
            userList.page = 20;
            userList.update();
        }
    } else if (window.innerWidth < 992) {
        if (userList.page !== 18) {
            userList.page = 18;
            userList.update();
        }
    } else {
        if (userList.page !== 40) {
            userList.page = 40;
            userList.update();
        }
    }
}

document.addEventListener("DOMContentLoaded", alphapostsReady);
window.addEventListener("resize", updateAlphapostsPageSize);
